import { Outlet, useLocation } from "react-router-dom"

import AuthBoundary from "@/app/boundaries/AuthBoundary"
import {
  HELP_CENTER_NAVIGATION,
  HelpCenterLayout,
  HelpCenterProvider,
  HelpCenterSidebar,
  useHelpCenterContext
} from "@/areas/help-center"

function HelpCenterLayoutInner() {
  const location = useLocation()
  const { searchQuery, setSearchQuery, activeSectionId, navigateToSection } = useHelpCenterContext()

  return (
    <HelpCenterLayout
      sidebar={
        <HelpCenterSidebar
          navItems={HELP_CENTER_NAVIGATION}
          activeSectionId={activeSectionId}
          searchValue={searchQuery}
          onSearchChange={setSearchQuery}
          onNavigate={navigateToSection}
          currentPath={location.pathname}
        />
      }
    >
      <Outlet />
    </HelpCenterLayout>
  )
}

function HelpCenterPageLayout() {
  return (
    <AuthBoundary>
      <HelpCenterProvider>
        <HelpCenterLayoutInner />
      </HelpCenterProvider>
    </AuthBoundary>
  )
}

export default HelpCenterPageLayout
